module.exports = __webpack_public_path__ + "img/close-circle.5ec5681e.svg";